import Vue from "vue";
import MlService from "../components/services/multilingual-service";
import { Widget } from "../components/services/participant-service";
import QuillHtmlDirective from "./QuillHtmlDirective";
import $ from "jquery";
const url = window.location.href;
Vue.directive("translate", {
  bind: (el, binding) => {
    const lang = new MlService();
    const pwebLang = new Widget();
    if (binding.value !== undefined && typeof binding.value !== "object" && binding.value !== "" && binding.value !== "EN" && binding.value !== "en") {
      pwebLang.languageCulture = binding.value;
      if (binding.modifiers && binding.modifiers.title) {
        el.title = pwebLang.i18n(binding.arg) !== false ? pwebLang.i18n(binding.arg) : el.title;
      } else if (binding.modifiers && binding.modifiers.placeholder) {
        el.placeholder = pwebLang.i18n(binding.arg) !== false ? pwebLang.i18n(binding.arg) : el.placeholder;
      } else if (binding.modifiers && binding.modifiers.title) {
        el.title = pwebLang.i18n(binding.arg) !== false ? pwebLang.i18n(binding.arg) : el.title;
      } else {
        el.innerHTML = pwebLang.i18n(binding.arg) !== false ? pwebLang.i18n(binding.arg) : el.innerHTML;
      }
    } else if (binding.value && typeof binding.value === "object" && binding.value.key !== "" && binding.value.val && binding.value.val !== "EN" && binding.value.val !== "en" && binding.arg == "dynamic_string") {
      pwebLang.languageCulture = binding.value.val;
      if (binding.modifiers && binding.modifiers.title) {
        el.title = pwebLang.i18nActivities(binding.value.key) !== false ? pwebLang.i18nActivities(binding.value.key) : el.title;
      } else if (binding.modifiers && binding.modifiers.placeholder) {
        el.placeholder = pwebLang.i18nActivities(binding.value.key) !== false ? pwebLang.i18nActivities(binding.value.key) : el.placeholder;
      } else if (binding.modifiers && binding.modifiers.title) {
        el.title = pwebLang.i18nActivities(binding.value.key) !== false ? pwebLang.i18nActivities(binding.value.key) : el.title;
      } else {
        el.innerHTML = pwebLang.i18nActivities(binding.value.key) !== false ? pwebLang.i18nActivities(binding.value.key) : el.innerHTML;
      }
    } else if (binding.value && typeof binding.value === "object" && binding.value.key !== "" && binding.value.val && binding.value.val !== "EN" && binding.value.val !== "en") {
      //cssrs translate
      if (binding.value.optionId) {
        const newKey = binding.value.key + binding.value.optionLable + binding.value.optionId + binding.arg;
        lang.languageCulture = binding.value.val;
        el.innerHTML = lang.i18nTranslate(newKey) !== false ? lang.i18nTranslate(newKey) : binding.value.html;
      } else {
        const newKey = binding.arg ? binding.value.key + binding.arg : binding.value.key;
        lang.languageCulture = binding.value.val;
        el.innerHTML = lang.i18nTranslate(newKey) !== false ? lang.i18nTranslate(newKey) : binding.value.html;
      }
    } else if (binding.value && binding.value.key !== "" && binding.value.val && binding.value.val !== "EN" && binding.value.val !== "en") {
      const newKey = binding.value.key + binding.arg;
      pwebLang.languageCulture = binding.value.val;
      el.innerHTML = pwebLang.i18n(newKey) !== false ? pwebLang.i18n(newKey) : el.innerHTML;
    }
  },
  update: (el, binding) => {
    const lang = new MlService();
    const pwebLang = new Widget();
    if (binding.value !== undefined && typeof binding.value !== "object" && binding.value !== "") {
      pwebLang.languageCulture = binding.value;
      if (binding.modifiers && binding.modifiers.title) {
        el.title = pwebLang.i18n(binding.arg) !== false ? pwebLang.i18n(binding.arg) : el.title;
      } else if (binding.modifiers && binding.modifiers.placeholder) {
        el.placeholder = pwebLang.i18n(binding.arg) !== false ? pwebLang.i18n(binding.arg) : el.placeholder;
      } else if (binding.modifiers && binding.modifiers.title) {
        el.title = pwebLang.i18n(binding.arg) !== false ? pwebLang.i18n(binding.arg) : el.title;
      } else {
        el.innerHTML = pwebLang.i18n(binding.arg) !== false ? pwebLang.i18n(binding.arg) : el.innerHTML;
      }
    } else if (binding.value && typeof binding.value === "object" && binding.value.key !== "" && binding.value.val && binding.value.val !== "EN" && binding.value.val !== "en" && binding.arg == "dynamic_string") {
      pwebLang.languageCulture = binding.value.val;
      if (binding.modifiers && binding.modifiers.title) {
        el.title = pwebLang.i18nActivities(binding.value.key) !== false ? pwebLang.i18nActivities(binding.value.key) : el.title;
      } else if (binding.modifiers && binding.modifiers.placeholder) {
        el.placeholder = pwebLang.i18nActivities(binding.value.key) !== false ? pwebLang.i18nActivities(binding.value.key) : el.placeholder;
      } else if (binding.modifiers && binding.modifiers.title) {
        el.title = pwebLang.i18nActivities(binding.value.key) !== false ? pwebLang.i18nActivities(binding.value.key) : el.title;
      } else {
        el.innerHTML = pwebLang.i18nActivities(binding.value.key) !== false ? pwebLang.i18nActivities(binding.value.key) : el.innerHTML;
      }
    } else if (binding.value && typeof binding.value === "object" && binding.value.key !== "" && binding.value.val) {
      //cssrs translate
      if (binding.value.optionId) {
        const newKey = binding.value.key + binding.value.optionLable + binding.value.optionId + binding.arg;
        lang.languageCulture = binding.value.val;
        el.innerHTML = lang.i18nTranslate(newKey) !== false ? lang.i18nTranslate(newKey) : binding.value.html;
      } else {
        const newKey = binding.arg ? binding.value.key + binding.arg : binding.value.key;
        lang.languageCulture = binding.value.val;
        el.innerHTML = lang.i18nTranslate(newKey) !== false ? lang.i18nTranslate(newKey) : binding.value.html;
      }
    } else if (binding.value && binding.value.key !== "" && binding.value.val) {
      const newKey = binding.value.key + binding.arg;
      pwebLang.languageCulture = binding.value.val;
      el.innerHTML = pwebLang.i18n(newKey) !== false ? pwebLang.i18n(newKey) : el.innerHTML;
    }
  }
});
Vue.directive("quillHtml", new QuillHtmlDirective());
Vue.directive("vue-tel-label", {
  bind: (el, binding, vnode) => {
    const vueTelInput = $(el);
    const countryDD = $(vueTelInput).find(".vti__dropdown");
    const pwebLang = new Widget();
    const noLabels = !!(binding.modifiers.nolabels && binding.modifiers.nolabels == true);
    const countryLabel = $('<label class="country-label text-capitalize">' + pwebLang.translate("countrycode_placeholder_text", "Country Code") + "</label>");
    if (!noLabels) {
      countryDD.append(countryLabel);
    }
    //
    const input = $(vueTelInput).find("input");

    const trim0 = () => {
      if (input.val().trim().length > 0 && vnode.child.phoneObject && vnode.child.phoneObject.valid && vnode.child.phoneObject.number) {
        if (vnode.child.phoneObject.number.national.charAt(0) == "0") {
          input.val(vnode.child.phoneObject.number.national.substring(1));
        }
      }
    };

    input.on("input", () => trim0());
    vnode.child.onValidated = evt => trim0(evt);
    const checkVal = (input, evt) => {
      trim0();
      if (($(input).val().length == 0 && evt) || $(input).val().length > 0) {
        $(vueTelInput).addClass("input-filled");
        $(vueTelInput).removeClass("input-empty");
      } else {
        $(vueTelInput).removeClass("input-filled");
        $(vueTelInput).addClass("input-empty");
      }
    };

    const onFocus = target => {
      trim0();
      if (!$(vueTelInput).hasClass("input-filled")) {
        $(vueTelInput).addClass("input-filled");
        $(vueTelInput).removeClass("input-empty");
        $(target).trigger("focus");
        $(target).attr("placeholder", " ");
      }
    };

    const capitalizeValue = () => {
      if (binding.modifiers.capitalize) {
        return binding.value != null
          ? binding.value
              .split(" ")
              .map(word => word[0].toUpperCase() + word.substring(1))
              .join(" ")
          : "";
      } else {
        return binding.value;
      }
    };

    checkVal(input);
    input.on("keyup", evt => checkVal(evt.target, evt));
    input.on("blur", evt => checkVal(evt.target));
    input.on("focus", () => onFocus(input));
    const numberLabel = $('<label class="number-label">' + capitalizeValue() + "</label>");
    numberLabel.on("click", () => onFocus(input));
    if (!noLabels) {
      numberLabel.insertAfter(input);
    }
    input.trigger("input");
  },
  update: (el, binding, vnode) => {
    const vueTelInput = $(el);
    const input = $(vueTelInput).find("input");

    const trim0 = () => {
      if (input.val().trim().length > 0 && vnode.child.phoneObject && vnode.child.phoneObject.valid && vnode.child.phoneObject.number) {
        if (vnode.child.phoneObject.number.national.charAt(0) == "0") {
          input.val(vnode.child.phoneObject.number.national.substring(1));
        }
      }
    };
    trim0();
    if ($(input).val().length > 0) {
      $(vueTelInput).addClass("input-filled");
      $(vueTelInput).removeClass("input-empty");
    } else {
      $(vueTelInput).removeClass("input-filled");
      $(vueTelInput).addClass("input-empty");
    }
  }
});
if (url.includes("/participants/web/")) {
  new Vue({ el: "#participants-portal" });
}

if (url.includes("/studies/")) {
  new Vue({ el: "#clinro-c-ssr-form" });
}
